import React from 'react';
import styled from 'styled-components';
import type { GameModeConfig } from './GameModeVariants';
import { getHighScores } from '../utils/highScore';
import { useT } from '../i18n';

// CHANGE (2026-08-15): ⚡-snabbstartsmenyn (FAB + panel) borttagen – den
// dubblerade lägena under "Avancerade lägen" och konkurrerade med mute-FAB:en
// om hörnen på startskärmen. Kvar här: highscore-previewn.
// Typen QuickStartTarget behålls för URL-shortcuts (?shortcut=speed etc.)
// som hanteras i YatzyGameManager.

export type QuickStartTarget = 'speed' | 'reverse' | 'blitz' | 'best-of-3';

// Highscore preview styles (motsvarar tidigare inline-styling i YatzyGameManager)
const HighScorePreviewBox = styled.div`
  margin: 18px auto 0;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 14px;
  padding: 14px 16px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
`;

const HighScoreRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

const HighScoreSelect = styled.select`
  padding: 8px 10px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: #fff;
  font-size: 14px;
`;

export const StartQuickPanel: React.FC<{
  modes: GameModeConfig[];
}> = ({ modes }) => {
  const t = useT();
  // CHANGE (2026-02-23): Highscore-preview på startsidan (lokal).
  const [highScoreModeId, setHighScoreModeId] = React.useState<string>('classic');

  const highScoreModes = React.useMemo(() => {
    const allowed = new Set(['classic', 'maxi', 'forced-classic', 'forced-maxi', 'speed', 'reverse', 'blitz', 'best-of-3']);
    return modes.filter(m => allowed.has(m.id));
  }, [modes]);

  const topLocalHighScore = React.useMemo(() => {
    const list = getHighScores(highScoreModeId, 'local');
    return list[0] || null;
  }, [highScoreModeId]);

  return (
    <HighScorePreviewBox aria-label="Highscore på startsidan">
      <HighScoreRow>
        <div style={{ fontWeight: 700, color: '#222' }}>{t('start.highscore.title')}</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: 13, color: '#444', opacity: 0.85 }}>{t('start.highscore.mode')}</span>
          <HighScoreSelect
            aria-label="Välj spelläge för highscore"
            value={highScoreModeId}
            onChange={(e) => setHighScoreModeId(e.target.value)}
          >
            {highScoreModes.map(m => (
              <option key={m.id} value={m.id}>
                {m.name}
              </option>
            ))}
          </HighScoreSelect>
        </div>
      </HighScoreRow>
      <div style={{ marginTop: 10, color: '#333', fontSize: 14 }}>
        {topLocalHighScore ? (
          <>
            <strong>{topLocalHighScore.playerName}</strong> — {topLocalHighScore.score}p{' '}
            <span style={{ opacity: 0.7 }}>({topLocalHighScore.date})</span>
          </>
        ) : (
          <span style={{ opacity: 0.75 }}>{t('start.highscore.empty')}</span>
        )}
      </div>
      {highScoreModeId === 'reverse' && (
        <div style={{ marginTop: 6, fontSize: 12, opacity: 0.75, color: '#333' }}>{t('start.highscore.reverseNote')}</div>
      )}
    </HighScorePreviewBox>
  );
};

export default StartQuickPanel;
